/**
 * DevExtreme (esm/common/core/environment.js)
 * Version: 24.2.6
 * Build date: Mon Mar 17 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import devices from "./environment/devices";
import hideTopOverlay from "./environment/hide_top_overlay";
import initMobileViewport from "./environment/init_mobile_viewport";
import {
    getTimeZones
} from "./environment/time_zone_utils";
export {
    devices,
    hideTopOverlay,
    initMobileViewport,
    getTimeZones
};
